var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSelect',_vm._g(_vm._b({attrs:{"items":_vm.bankAccountTypeList,"item-text":"name","item-value":"id","hide-details":"auto"}},'VSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }